import React, { useState, useCallback, useContext } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler } from 'reactstrap';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';
import Submenu from './Submenu';

import './NavMenu.css';
import { ParameterContext } from '../contexts/ParameterContext';
import { AuthContext } from '../contexts/AuthContext';

export function NavMenu() {
    const [collapsed, setCollapsed] = useState(true);

    const { parameters } = useContext(ParameterContext)
    const { user } = useContext(AuthContext);

    const testRegParam = parameters.nomParameters.find(x => x.param_name === 'TEST_REG');
    const hideParentLogin = parameters.nomParameters.find(x => x.param_name === 'HIDE_PARENT_LOGIN');
    const hideRankingMenu = parameters.nomParameters.find(x => x.param_name === 'HIDE_RANKING_PUBLIC_MENU');
    const linkAreas = parameters.nomParameters.find(x => x.param_name === 'LINK_AREAS');
    //const showMulticipalityLogo = parameters?.nomParameters?.find(x => x.param_name === "SHOW_MULTICIPALITY_LOGO")?.value?.trim();

    const location = useLocation();
    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

    const toggleNavbar = useCallback(() => {
        if (JSON.parse(localStorage.getItem('isOnMobile'))) {
            setCollapsed(!collapsed);
        }
    }, [collapsed]);


    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 first-nav" container light>
                {hideParentLogin.value == 0 && !user.token &&
                    <NavLink to="/parent-login" className="text-white login"><span className=" pi pi-sign-in" style={{ fontSize: '1rem' }}></span> Вход</NavLink>
                }
                {testRegParam.value == 0 && !user.token &&
                    <NavLink to="/register" className="text-white login" ><span className=" pi pi-user-plus" style={{ fontSize: '1rem' }}></span> Регистрация</NavLink>
                }
                {user.token &&
                    <NavLink to="/parent/logout" className="text-white login "><span className="pi pi-sign-out" style={{ fontSize: '1rem', fontWeight: 'bolder' }}></span> {user.fullname} Изход</NavLink>
                }
            </Navbar>

            <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
                <NavbarBrand tag={Link} to="/">
                    {/*{showMulticipalityLogo === "1" ? (*/}
                    {/*    <div className="nav-logo-wrapper">*/}
                    {/*        <img*/}
                    {/*            width="50px" style={{ opacity: 0.6 }}*/}
                    {/*            src="/img/logo_nav.png"*/}
                    {/*            alt="Municipality Logo"*/}
                    {/*            className="municipality-logo"*/}
                    {/*        />*/}
                    {/*        <b className="bolder">*/}
                    {/*            I КЛАС*/}
                    {/*            <br />*/}
                    {/*            {parameters.municipality.obshtina_name}*/}
                    {/*        </b>*/}
                    {/*    </div>*/}
                    {/*) : (*/}
                        <b className="bolder">
                            I КЛАС
                            <br />
                        {/*община*/}
                        {parameters.municipality.obshtina_name}
                        </b>
                    {/*)}*/}
                </NavbarBrand>
                <NavbarToggler onClick={toggleNavbar} className="mr-2 cust_toggler" />
                <Collapse className="d-sm-inline-flex flex-sm-row-reverse public-nav-l" isOpen={!collapsed} navbar>
                    <ul className="navbar-nav flex-grow d-flex">
                        <NavLink to={`${user.token ? '/parent' : '/'}`} className="text-white head_but_cust home-link" onClick={toggleNavbar} ><i className="pi pi-home home"></i></NavLink>
                        {user.token
                            ? <>
                                <NavLink to={testRegParam.value == 0 ? 'register' : testRegParam.value} className="text-white head_but_cust " onClick={toggleNavbar} >Ново заявление</NavLink>
                                <NavLink to={`/parent/profile/${user.id}`} className="text-white head_but_cust " onClick={toggleNavbar} >Моят профил</NavLink>
                                <NavLink to="/parent/change-password" className="text-white head_but_cust " onClick={toggleNavbar} >Промяна на паролата</NavLink>
                            </>
                            : <>
                                <NavLink to="/news" className="text-white head_but_cust" onClick={toggleNavbar} >Новини</NavLink>
                                <NavLink to="/instructions" className="text-white head_but_cust" onClick={toggleNavbar} >Указания</NavLink>
                                <NavLink to="/rules" className="text-white head_but_cust" onClick={toggleNavbar}>Наредби</NavLink>
                                <NavLink to="/schools" className="text-white head_but_cust" onClick={toggleNavbar} >Училища</NavLink>
                                {linkAreas && linkAreas?.value != 0
                                    ? <NavLink to="https://obshtinaruse.bg/priem-v-parvi-klas-vazhno-za-roditeli" className="text-white head_but_cust" onClick={toggleNavbar} >Райони</NavLink>
                                    : <NavLink to="/areas" className="text-white head_but_cust" onClick={toggleNavbar} >Райони</NavLink>
                                }

                                <NavLink to="/grafik" className="text-white head_but_cust" onClick={toggleNavbar}>График</NavLink>

                           

                                {hideRankingMenu.value == 0 &&
                                    <div
                                        className={location.pathname === '/ratings' || location.pathname === '/free-places' ? 'link-container text-white head_but_cust act' : 'link-container text-white head_but_cust'}
                                        onMouseEnter={() => setIsSubmenuOpen(true)}
                                        onMouseLeave={() => setIsSubmenuOpen(false)}
                                    >
                                        Класирания <span className="pi pi-angle-down"></span>
                                        {isSubmenuOpen && <Submenu toggleNavbar={toggleNavbar} />}
                                    </div>
                                }
                            </>
                        }

                        {/*<NavLink to="/foreigners" className="text-white head_but_cust">Чужденци</NavLink>*/}

                    </ul>
                </Collapse>
            </Navbar>
            {user.token
                ? <>
                    <div className="banner">
                        <Container>
                            <div className='header_bg_second'>
                                <div className='header_text_parent'>
                                    <div className="header_text1">Родителски профил</div>
                                </div>
                            </div>
                        </Container>
                    </div>
                </>
                : <>
                    <div className="banner">
                        <Container>
                            <div className={location.pathname === '/' ? 'header_bg' : 'header_bg_second'}>
                                <div className={location.pathname === '/' ? 'header_text d-none d-sm-block d-sm-none d-md-block' : 'd-none'}>
                                    <div className="header_text1">Прием в 1-ви клас</div>                              
                                    <div className="header_text2">община  {parameters.municipality.obshtina_name}</div>
                                </div>
                            </div>
                        </Container>
                    </div>
                </>
            }
        </header>
    );
}